import { AlertTriangle } from "lucide-react";

/**
 * Persistent, non-dismissible compliance notices required by Terms v2.0.
 * These are intentionally NOT toasts or one-time modals — they must remain
 * visible next to the content they qualify. Rendered inline as a calm amber
 * banner so they read as guidance rather than an error.
 */
const NOTICES = {
  ai: "AI-generated draft. Review and verify before publishing — especially any claim about an opponent, a public official, or a voting record.",
  finance: "This is a record-keeping tool, not a filing service. Verify all figures with your treasurer or counsel before filing.",
  deadline: "Dates and steps shown here are general references. Confirm every filing requirement and deadline with your election authority — requirements vary by state, office, and filing status.",
};

export function ComplianceNotice({ kind, className = "" }) {
  const text = NOTICES[kind];
  if (!text) return null;
  return (
    <div
      role="note"
      data-testid={`compliance-notice-${kind}`}
      className={`flex items-start gap-2.5 rounded-lg border border-amber-200 bg-amber-50 px-3.5 py-2.5 text-xs sm:text-sm text-amber-900 ${className}`}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0 text-amber-600" />
      <span className="leading-snug">{text}</span>
    </div>
  );
}

export default ComplianceNotice;
